import { isIsoDate } from '../validation/is-iso-date.function';
import { isIsoDateTime } from '../validation/is-iso-date-time.function';
import { isIsoDateTimeTz } from '../validation/is-iso-date-time-tz.function';
import { IsoDateTimeTz, IsoTimeOffset, IsoTimeTz } from '../../types/iso-date';
import { isIsoTimeTz } from '../validation/is-iso-time-tz.function';
import { isIsoTimeOffset } from '../validation/is-iso-time-offset.function';
import { deconstructDate } from '../helper/deconstruct-date.function';
import { constructOffset } from '../helper/construct-date.function';

/**
 * Extract the timezone part from an ISO 8601 string.
 *
 * Supported inputs:
 * - Date-only (YYYY-MM-DD): returns null
 * - Date-time without timezone (YYYY-MM-DDTHH:mm:ss[.fraction]): returns null
 * - Date-time with timezone (YYYY-MM-DDTHH:mm:ss[.fraction](Z|±HH:MM)): returns 'Z' or the '±HH:MM' offset
 *
 * Throws if the input is not a valid ISO date/date-time string per the above forms.
 */
export function getTimeOffset(date: IsoDateTimeTz | IsoTimeTz): IsoTimeOffset {
  const { offset } = deconstructDate(date);
  if (!offset)
    throw new Error('getTimeZone: input must include a timezone (Z or ±HH:MM)');
  return constructOffset(offset);
}
